import type { AllRouteEndpoints } from "../routeTypes";

export const customObjectsCustomObjectTypeAttributes = "/data_objects/data_object_type_attributes";

export const customObjectsCustomObjectTypeAttributesCacheKeys: AllRouteEndpoints[] = [
  "/data_objects/data_object_type_attributes",
];
